import { risapi } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';
import { getAPIFullUrl, getAxiosConfig } from './risapi';

export const registerClub = async (newClubData, callback) => {
    try {
        // This is a public endpoint, so we don't need an auth token from getAxiosConfig()
        const headers = {
            'Content-Type': 'multipart/form-data',
        };

        const formData = convertJsonToFormData(newClubData);

        // Make the API call using the pre-configured risapi client
        const response = await risapi.post('/api/register-club', formData, { headers });

        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        // The callback receives the error object for the component to handle
        callback(error);
    }
};

export const getSubscriptionPlans = async (filterParameters, callback) => {
    try {
        // Assuming this might be a protected route, we use getAxiosConfig()
        const response = await risapi.get(getAPIFullUrl('/api/subscription-plans', filterParameters), getAxiosConfig());

        if (response.status === 200) {
            callback(response.data);
        }
    } catch (errorResponse) {
        callback(errorResponse);
    }
};

